import type { ProviderName } from '../types';

export function buildGrantUrl(path: string, providerName: ProviderName, scopes: string[], state?: string) {
  const url = new URL(path, window.location.origin);

  url.searchParams.append('provider_name', providerName);

  for (const scope of scopes) {
    url.searchParams.append('scopes[]', scope);
  }

  if (state) {
    url.searchParams.append('state', state);
  }

  return url;
}
